import {createFileRoute, Navigate} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/football/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <Navigate to="/football/leagues/" />;
}
